/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Sv } from './Sv';

const { GlobalVar } = Utils;

class Servant extends Sv {
    constructor() {
        super();
        this.baseUrl += '/servant';
    }

    data({ servantName, servantStatus, currentPage, pageSize } = {}) {
        return super.get('/data', {
            servantName,
            servantStatus,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { servantLogo } = json.data.data;
            if (!servantLogo) {
                json.data.data.servantLogo = [];
            } else {
                json.data.data.servantLogo = servantLogo.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            if (json.data.data.interfaceConfig) {
                json.data.data.payEffectiveTime = json.data.data.interfaceConfig.payEffectiveTime;
                json.data.data.examNotes = json.data.data.interfaceConfig.examNotes;
                json.data.data.testMemberIds = json.data.data.interfaceConfig.testMemberIds;
                json.data.data.courseHourMinute = json.data.data.interfaceConfig.courseHourMinute;
                json.data.data.sellerName = json.data.data.interfaceConfig.sellerName;
                json.data.data.sellerTaxIdentificationSn = json.data.data.interfaceConfig.sellerTaxIdentificationSn;
                json.data.data.sellerAddress = json.data.data.interfaceConfig.sellerAddress;
                json.data.data.sellerPhone = json.data.data.interfaceConfig.sellerPhone;
                json.data.data.sellerBankName = json.data.data.interfaceConfig.sellerBankName;
                json.data.data.sellerBankSn = json.data.data.interfaceConfig.sellerBankSn;
                json.data.data.isDutyFree = json.data.data.interfaceConfig.isDutyFree;
                json.data.data.taxrate = json.data.data.interfaceConfig.taxrate;
                json.data.data.accessToken = json.data.data.interfaceConfig.accessToken;
                json.data.data.printSecret = json.data.data.interfaceConfig.printSecret;
                json.data.data.goldenTaxNo = json.data.data.interfaceConfig.goldenTaxNo;
                json.data.data.verticalGroupingNum = json.data.data.interfaceConfig.verticalGroupingNum;
                json.data.data.payee = json.data.data.interfaceConfig.payee;
                json.data.data.clerk = json.data.data.interfaceConfig.clerk;
                json.data.data.checker = json.data.data.interfaceConfig.checker;
                const { invoiceTypes } = json.data.data.interfaceConfig;
                if (!invoiceTypes) {
                    json.data.data.invoiceTypes = [];
                } else {
                    json.data.data.invoiceTypes = invoiceTypes.split(',');
                }
                json.data.data.subsidyBankCard = json.data.data.interfaceConfig.subsidyBankCard;
                json.data.data.isAllowOrderInvoice = json.data.data.interfaceConfig.isAllowOrderInvoice;
                json.data.data.orderInvoiceTips = json.data.data.interfaceConfig.orderInvoiceTips;
                json.data.data.isShowCertificateOfAchievement =
                    json.data.data.interfaceConfig.isShowCertificateOfAchievement;
                json.data.data.customerTel = json.data.data.interfaceConfig.customerTel;
                json.data.data.schoolMapUrl = json.data.data.interfaceConfig.schoolMapUrl;
                json.data.data.meiQiaEntId = json.data.data.interfaceConfig.meiQiaEntId;
                json.data.data.schoolReceiveTemplateId = json.data.data.interfaceConfig.schoolReceiveTemplateId;
                json.data.data.enterpriseSchoolReceiveTemplateId =
                    json.data.data.interfaceConfig.enterpriseSchoolReceiveTemplateId;
                json.data.data.expressDeliveryTemplateId = json.data.data.interfaceConfig.expressDeliveryTemplateId;
                json.data.data.enterpriseExpressDeliveryTemplateId =
                    json.data.data.interfaceConfig.enterpriseExpressDeliveryTemplateId;
                json.data.data.schoolAddress = json.data.data.interfaceConfig.schoolAddress;
                json.data.data.schoolRegionId = json.data.data.interfaceConfig.schoolRegionId;
                json.data.data.senderName = json.data.data.interfaceConfig.senderName;
                json.data.data.senderMobile = json.data.data.interfaceConfig.senderMobile;
                json.data.data.isDealApplyReview = json.data.data.interfaceConfig.isDealApplyReview;
                json.data.data.schoolCode = json.data.data.interfaceConfig.schoolCode;

                const { sealImage } = json.data.data.interfaceConfig;
                if (!sealImage) {
                    json.data.data.sealImage = [];
                } else {
                    json.data.data.sealImage = sealImage.split(',').reduce((prev, curr) => {
                        prev.push({
                            name: curr,
                            address: GlobalVar.fileBasePath + curr,
                        });
                        return prev;
                    }, []);
                }
                const { trainingSealImage } = json.data.data.interfaceConfig;
                if (!trainingSealImage) {
                    json.data.data.trainingSealImage = [];
                } else {
                    json.data.data.trainingSealImage = trainingSealImage.split(',').reduce((prev, curr) => {
                        prev.push({
                            name: curr,
                            address: GlobalVar.fileBasePath + curr,
                        });
                        return prev;
                    }, []);
                }
            }
            return json;
        });
    }

    save({
        id,
        orgId,
        servantName,
        servantSn,
        servantWebsite,
        servantLogo,
        servantRegionId,
        servantAddress,
        servantHouseNumber,
        servantPostcode,
        servantEmail,
        principalName,
        principalTel,
        paymentMode,
        onlinePaymentType,
        remarks,
        servantStatus,
        memberAccountSign,
        payEffectiveTime,
        examNotes,
        testMemberIds,
        courseHourMinute,
        sellerName,
        sellerTaxIdentificationSn,
        sellerAddress,
        sellerPhone,
        sellerBankName,
        sellerBankSn,
        isDutyFree,
        taxrate,
        accessToken,
        printSecret,
        goldenTaxNo,
        verticalGroupingNum,
        customerImage,
        payee,
        clerk,
        checker,
        invoiceTypes,
        subsidyBankCard,
        isAllowOrderInvoice,
        orderInvoiceTips,
        officialAccountName,
        enterpriseCooperationContactNumber,
        invoiceContactNumber,
        isShowCertificateOfAchievement,
        customerTel,
        schoolMapUrl,
        meiQiaEntId,
        schoolReceiveTemplateId,
        enterpriseSchoolReceiveTemplateId,
        expressDeliveryTemplateId,
        enterpriseExpressDeliveryTemplateId,
        schoolAddress,
        schoolRegionId,
        senderName,
        senderMobile,
        isDealApplyReview,
        sealImage,
        trainingSealImage,
        mustReviewRemindDay,
        schoolCode,
    } = {}) {
        const servantLogoStr = servantLogo
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        const sealImageStr = sealImage
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        const trainingSealImageStr = trainingSealImage
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        const customerImageStr = customerImage
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        const invoiceTypeStr = invoiceTypes
            .reduce((prev, curr) => {
                prev.push(curr);
                return prev;
            }, [])
            .join(',');
        const interfaceConfig = {
            payEffectiveTime,
            examNotes,
            testMemberIds,
            courseHourMinute,
            sellerName,
            sellerTaxIdentificationSn,
            sellerAddress,
            sellerPhone,
            sellerBankName,
            sellerBankSn,
            isDutyFree,
            taxrate,
            accessToken,
            printSecret,
            goldenTaxNo,
            verticalGroupingNum,
            customerImage: customerImageStr,
            payee,
            clerk,
            checker,
            invoiceTypes: invoiceTypeStr,
            subsidyBankCard,
            isAllowOrderInvoice,
            orderInvoiceTips,
            officialAccountName,
            enterpriseCooperationContactNumber,
            invoiceContactNumber,
            isShowCertificateOfAchievement,
            customerTel,
            schoolMapUrl,
            meiQiaEntId,
            schoolReceiveTemplateId,
            enterpriseSchoolReceiveTemplateId,
            expressDeliveryTemplateId,
            enterpriseExpressDeliveryTemplateId,
            schoolAddress,
            schoolRegionId,
            senderName,
            senderMobile,
            isDealApplyReview,
            sealImage: sealImageStr,
            trainingSealImage: trainingSealImageStr,
            mustReviewRemindDay,
            schoolCode,
        };
        return super.post('/save', {
            id,
            orgId,
            servantName,
            servantSn,
            servantWebsite,
            servantLogo: servantLogoStr,
            servantRegionId,
            servantAddress,
            servantHouseNumber,
            servantPostcode,
            servantEmail,
            principalName,
            principalTel,
            paymentMode,
            onlinePaymentType,
            remarks,
            servantStatus,
            memberAccountSign,
            interfaceConfig: JSON.stringify(interfaceConfig),
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    getServantInfo() {
        return super.get('/getServantInfo').then(json => {
            const { servantLogo } = json.data.data;
            if (!servantLogo) {
                json.data.data.servantLogo = [];
            } else {
                json.data.data.servantLogo = servantLogo.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            if (json.data.data.interfaceConfig) {
                json.data.data.payEffectiveTime = json.data.data.interfaceConfig.payEffectiveTime;
                if (!json.data.data.interfaceConfig.customerImage) {
                    json.data.data.customerImage = [];
                } else {
                    json.data.data.customerImage = json.data.data.interfaceConfig.customerImage
                        .split(',')
                        .reduce((prev, curr) => {
                            prev.push({
                                name: curr,
                                address: GlobalVar.fileBasePath + curr,
                            });
                            return prev;
                        }, []);
                }

                json.data.data.isAllowOrderInvoice = json.data.data.interfaceConfig.isAllowOrderInvoice;
                json.data.data.orderInvoiceTips = json.data.data.interfaceConfig.orderInvoiceTips;
                json.data.data.officialAccountName = json.data.data.interfaceConfig.officialAccountName;
                json.data.data.enterpriseCooperationContactNumber =
                    json.data.data.interfaceConfig.enterpriseCooperationContactNumber;
                json.data.data.invoiceContactNumber = json.data.data.interfaceConfig.invoiceContactNumber;
                json.data.data.customerTel = json.data.data.interfaceConfig.customerTel;
                const { invoiceTypes } = json.data.data.interfaceConfig;
                if (!invoiceTypes) {
                    json.data.data.invoiceTypes = [];
                } else {
                    json.data.data.invoiceTypes = invoiceTypes.split(',');
                }
                json.data.data.schoolMapUrl = json.data.data.interfaceConfig.schoolMapUrl;
                json.data.data.schoolReceiveTemplateId = json.data.data.interfaceConfig.schoolReceiveTemplateId;
                json.data.data.enterpriseSchoolReceiveTemplateId =
                    json.data.data.interfaceConfig.enterpriseSchoolReceiveTemplateId;
                json.data.data.expressDeliveryTemplateId = json.data.data.interfaceConfig.expressDeliveryTemplateId;
                json.data.data.enterpriseExpressDeliveryTemplateId =
                    json.data.data.interfaceConfig.enterpriseExpressDeliveryTemplateId;
                json.data.data.schoolAddress = json.data.data.interfaceConfig.schoolAddress;
                json.data.data.schoolRegionId = json.data.data.interfaceConfig.schoolRegionId;
                json.data.data.senderName = json.data.data.interfaceConfig.senderName;
                json.data.data.senderMobile = json.data.data.interfaceConfig.senderMobile;
                json.data.data.mustReviewRemindDay = json.data.data.interfaceConfig.mustReviewRemindDay;
                json.data.data.schoolCode = json.data.data.interfaceConfig.schoolCode;

                const { sealImage } = json.data.data.interfaceConfig;
                if (!sealImage) {
                    json.data.data.sealImage = [];
                } else {
                    json.data.data.sealImage = sealImage.split(',').reduce((prev, curr) => {
                        prev.push({
                            name: curr,
                            address: GlobalVar.fileBasePath + curr,
                        });
                        return prev;
                    }, []);
                }
                const { trainingSealImage } = json.data.data.interfaceConfig;
                if (!trainingSealImage) {
                    json.data.data.trainingSealImage = [];
                } else {
                    json.data.data.trainingSealImage = trainingSealImage.split(',').reduce((prev, curr) => {
                        prev.push({
                            name: curr,
                            address: GlobalVar.fileBasePath + curr,
                        });
                        return prev;
                    }, []);
                }
            }
            return json;
        });
    }

    getServantAvailablePaymentMode() {
        return super.get('/getServantAvailablePaymentMode', {});
    }

    getServantPaymentTypeList() {
        return super.get('/getServantPaymentTypeList', {});
    }
}

export default new Servant();
export { Servant };
